module.exports = __webpack_public_path__ + "img/pt_logo@2x.6b41420e.png";